export default __webpack_public_path__ + "static/media/misc-pantry3-480w.b93afefd.webp";